import { Anschrift } from "./anschrift"

export class Lieferinformation {
    // BT-70
    name = ""
    // BT-71
    kennung = ""
    // BT-71-1
    kennungSchema = ""
    // BT-72
    lieferdatum: string | null | undefined

    lieferadresse = new Anschrift()

    get notEmpty(): boolean {
        return (this.name.trim().length > 0 || this.kennung.trim().length > 0 || !!this.lieferdatum || this.lieferadresse?.notEmpty) as boolean
    }

    toJSON() {
        return this.notEmpty
            ? {
                  name: this.name,
                  kennung: this.kennung,
                  kennungSchema: this.kennungSchema,
                  lieferadresse: this.lieferadresse,
                  lieferdatum: this.lieferdatum ? this.lieferdatum.substr(0, 10) : null,
              }
            : undefined
    }
}
